import { useState } from 'react';
import '../css/animatedinput.css';

const AnimatedInput = ({
  field,
  value,
  checked,
  onToggle,
  onChange,
  onSelectOption,
  error = '',
  autoComplete = 'off',
}) => {
  const [showPass, setShowPass] = useState(false);
  const [fieldValues, setFieldValues] = useState(field.fieldValues);

  const removeVietnameseTones = (str) => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/đ/g, 'd')
      .replace(/Đ/g, 'D');
  };

  const handleSearchKey = (e) => {
    onChange(e.target.value);
    const keyword = removeVietnameseTones(e.target.value.toLowerCase());

    setFieldValues(() => {
      if (!keyword) return field.fieldValues;

      const filterData = field.fieldValues.filter((option) => {
        const original = removeVietnameseTones(option.value.toLowerCase());
        return original.includes(keyword);
      });

      return filterData;
    });
  };

  const handleChange =
    field.fieldValues?.length > 0 ? handleSearchKey : onChange;

  return field.type === 'radio' ? (
    <div className="form-input-radio">
      <label htmlFor={field.key}>
        <span>
          {field.icon && <i className={field.icon}></i>}
          {field.name} {field.required && <sup>*</sup>}
        </span>
      </label>

      {field.listRadio.map((item, idx) => (
        <div className="form-check form-check-inline m-2">
          <input
            className="form-check-input"
            type={field.type}
            name={field.key}
            id={`${field.key}-${idx}`}
            value={item.value}
            checked={checked === item.value}
            required={field.required}
            onChange={onChange}
          />
          <label className="form-check-label" htmlFor={field.key}>
            {item.label}
          </label>
        </div>
      ))}
    </div>
  ) : (
    <div className={`form-input-animation ${error && 'mb-5'} `}>
      <input
        type={field.type === 'password' && showPass ? 'text' : field.type}
        name={field.key}
        id={field.key}
        className={`form-text ${error ? 'input-error' : ''}`}
        value={field.type === 'date' && value ? value.slice(0, 10) : value}
        onChange={handleChange}
        onFocus={field.fieldValues?.length > 0 ? onToggle : undefined}
        required={field.required}
        autoComplete={autoComplete}
        placeholder=" "
      />

      <label htmlFor={field.key}>
        <span>
          {field.icon && <i className={field.icon}></i>}
          {field.name} {field.required && <sup>*</sup>}
        </span>
      </label>
      {error && <div className="error-message">{error}</div>}

      {field.type === 'password' && (
        <span className="select-icon" onClick={() => setShowPass(!showPass)}>
          <i
            className={`${showPass ? 'ti ti-eye-off' : 'ti ti-eye'} login-icon`}
          ></i>
        </span>
      )}

      {field.fieldValues?.length > 0 && (
        <>
          <span className="select-icon">
            <i className="fas fa-chevron-down" style={{ fontSize: '11px' }} />
          </span>
          <div className="down-option mb-3">
            <ul className="p-0 m-0">
              {fieldValues.map((item) => (
                <li
                  key={item.id}
                  onClick={(e) => {
                    e.stopPropagation();
                    setTimeout(() => {
                      onSelectOption && onSelectOption(item.value);
                    }, 0);
                  }}
                >
                  {item.value}
                </li>
              ))}
            </ul>
          </div>
        </>
      )}
    </div>
  );
};

export default AnimatedInput;
